import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Link from 'gatsby-link';
import { media, theme } from 'styles';
import RelatedCaseStudy from './RelatedCaseStudy';

const Wrapper = styled.div`
  position: relative;

  ${media.laptop`
    display: flex;
    justify-content: space-between;
  `};
`;

const RelatedCaseStudyWrapper = styled(Link)`
  text-decoration: none;

  ${media.tablet`
    width: calc((100% - ${parseInt(theme.sp.xl, 10)}px) / 2);
  `};
`;

const propTypes = {
  relatedCaseStudies: PropTypes.arrayOf({}).isRequired,
};

function RelatedCaseStudies({ relatedCaseStudies }) {
  return (
    <Wrapper>
      {relatedCaseStudies.map(relatedCaseStudy => (
        <RelatedCaseStudyWrapper
          key={relatedCaseStudy.id}
          to={`/work/${relatedCaseStudy.slug}`}
        >
          <RelatedCaseStudy relatedCaseStudy={relatedCaseStudy} />
        </RelatedCaseStudyWrapper>
      ))}
    </Wrapper>
  );
}

RelatedCaseStudies.propTypes = propTypes;

export default RelatedCaseStudies;



// WEBPACK FOOTER //
// ./src/components/shared/RelatedCaseStudies/RelatedCaseStudies.jsx